import * as History from 'history';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0] !== undefined ? document.getElementsByTagName('base')[0].getAttribute('href') : '';
export const history = History.createBrowserHistory({ basename: baseUrl } as History.BrowserHistoryBuildOptions);